import React from 'react';

export const renderCellWithArray = (options: any) => {
  if (!options || options.length === 0) return <span></span>;

  const displayOptions =
    options.length > 2
      ? `${options[0]}, ${options[1]}, +${options.length - 2}`
      : options.join(', ');

  return <span>{displayOptions}</span>;
};
